import {
  useCardManagementStackScreensAreModals,
  useCardStackScreen,
} from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import * as CardActivity from '@/src/experiences/card-activity'
import * as CardPlatform from '@/src/experiences/card-platform'

export function useTransactionEventDetailsCardStackScreenProps() {
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()
  return useCardStackScreen({
    name: 'transaction-event/[id]',
    options: {
      title: 'Transaction Details',
      presentation: cardManagementStackScreensAreModals ? 'transparentModal' : 'modal',
    },
  })
}

const CardActivityTransactionScreen = CardPlatform.Screens.Gate({
  Highnote: CardActivity.Screens.Highnote.TransactionEventDetails,
  Platform: CardActivity.Screens.ActivityTransactionDetail,
})

export default function TransactionEventDetails() {
  return useTransactionEventDetailsCardStackScreenProps().Modal({
    children: <CardActivityTransactionScreen />,
  })
}
